/* eslint-disable */
import axios from "services/axiosConfig";

const API_URL = "/api/local";

class LocalService {
  // Crear local con isActive true
  static async createLocal(local) {
    try {
      const { data } = await axios.post(API_URL, local);
      return data?.local ?? null;
    } catch (error) {
      console.error("Error al crear el local:", error);
      throw error;
    }
  }

  // obtener todos los locales con isActive true
  static async getActiveLocals() {
    try {
      const { data } = await axios.get(API_URL);
      return data;
    } catch (error) {
      console.error("Error al obtener los locales activos:", error);
      return [];
    }
  }

  // obtener todos los locales con isActive false
  static async getInactiveLocals() {
    try {
      const { data } = await axios.get(`${API_URL}/inactive`);
      return data;
    } catch (error) {
      console.error("Error al obtener los locales inactivos:", error);
      return [];
    }
  }

  // obtener todos los locales de tipo Depósito (activos e inactivos)
static async getActiveLocalDepositoMachines() {
  try {
    const { data } = await axios.get(`${API_URL}/deposito`);
    return data;
  } catch (error) {
    console.error("Error al obtener los locales de depósito:", error);
    return [];
  }
}

// obtener todos los locales de tipo Desechos (activos e inactivos)
static async getActiveLocalDesechosMachines() {
  try {
    const { data } = await axios.get(`${API_URL}/desechos`);
    return data;
  } catch (error) {
    console.error("Error al obtener los locales de desechos:", error);
    return [];
  }
}

  // obtener todos los locales con isActive false, con los datos de sus dueños
  static async getAllInactiveLocalsWithOwners() {
    try {
      const { data } = await axios.get(`${API_URL}/owners/inactive`);
      return data;
    } catch (error) {
      console.error("Error al obtener los locales inactivos con sus dueños:", error);
      return [];
    }
  }

  // obtener locales de tipo Comercio inactivos, con los datos de sus dueños
static async getInactiveComercioWithOwners() {
  try {
    const { data } = await axios.get(`${API_URL}/owners/comercio/inactive`);
    return data;
  } catch (error) {
    console.error("Error al obtener los locales de comercio inactivos con sus dueños:", error);
    return [];
  }
}

  // obtener todos los locales con isActive true, con los datos de sus dueños
  static async getAllActiveLocalsWithOwners() {
    try {
      const { data } = await axios.get(`${API_URL}/owners`);
      return data;
    } catch (error) {
      console.error("Error al obtener los locales con sus dueños:", error);
      return [];
    }
  }

  // obtener locales de tipo Comercio activos, con los datos de sus dueños
static async getActiveComercioWithOwners() {
  try {
    const { data } = await axios.get(`${API_URL}/owners/comercio`);
    return data;
  } catch (error) {
    console.error("Error al obtener los locales de comercio activos con sus dueños:", error);
    return [];
  }
}

  // obtener un local por id con su dueño (Person)
static async getLocalWithOwnerById(id) {
  try {
    const { data } = await axios.get(`${API_URL}/owners/${id}`);
    return data;
  } catch (error) {
    console.error("Error al obtener el local con dueño:", error);
    return null;
  }
}

  // obtener todos los datos de un local por el id, con isActive true
  static async getLocalById(id) {
    try {
      const { data } = await axios.get(`${API_URL}/${id}`);
      return data;
    } catch (error) {
      console.error("Error al obtener el local:", error);
      return null;
    }
  }

  // modificar local, no modifica el campo isActive
  static async updateLocal(id, local) {
    try {
      const { data } = await axios.put(`${API_URL}/${id}`, local);
      return data;
    } catch (error) {
      console.error("Error al editar el local:", error);
      return null;
    }
  }

  // modificar atributo isActive true y lo pone false (Soft-delete)
  static async deleteLocal(id, payload = {}) {
    try {
      const response = await axios.delete(`${API_URL}/${id}`, {
        data: payload,
      });
      if (response.status === 204) {
        return { ok: true };
      }
      return { ok: false };
    } catch (error) {
      if (error.response && error.response.status === 409) {
        return {
          ok: false,
          conflict: true,
          message: error.response.data?.error ||
            "Retirá las máquinas antes de cerrar el depósito.",
        };
      }
      if (error.response && error.response.status === 400) {
        return {
          ok: false,
          invalid: true,
          code: error.response.data?.code || null,
          message: error.response.data?.error || "No se pudo cerrar el depósito.",
        };
      }
      console.error("Error al cerrar el depósito:", error);
      return { ok: false, error: true };
    }
  }

  // modifica atributo isActive false y lo pone true
  static async reactivateLocal(id) {
    try {
      const response = await axios.patch(`${API_URL}/${id}/reactivate`);
      return response.status === 204;
    } catch (error) {
      console.error("Error al reactivar el local:", error);
      return false;
    }
  }

  static async closeLocalAndMoveMachines(localId, payload) {
    try {
      const { data } = await axios.post(`${API_URL}/${localId}/close-and-move-machines`, payload);
      return data;
    } catch (error) {
      console.error("Error al cerrar el local y mover máquinas:", {
        localId,
        payload,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
      throw error;
    }
  }

  static async getCloseDateBounds(localId) {
    try {
      const { data } = await axios.get(`${API_URL}/${localId}/close-date-bounds`);
      return data || null;
    } catch (error) {
      console.error("Error al obtener limites de fecha para cerrar local:", {
        localId,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });
      return null;
    }
  }

  static async getClosedLocalsByOwner(personId) {
    try {
      const { data } = await axios.get(`${API_URL}/closed-by-owner/${personId}`);
      return data || [];
    } catch (error) {
      console.error("Error al obtener locales cerrados del dueño:", error);
      return [];
    }
  }

  static async reopenLocal(localId, payload = {}) {
    try {
      const { data } = await axios.post(`${API_URL}/${localId}/reopen`, payload);
      return data || null;
    } catch (error) {
      if (error.response && error.response.status === 409) {
        return {
          conflict: true,
          code: error.response.data?.code || null,
          message: error.response.data?.error || "No se pudo reabrir el local.",
        };
      }
      if (error.response && error.response.status === 400) {
        return {
          invalid: true,
          code: error.response.data?.code || null,
          message: error.response.data?.error || "No se pudo reabrir el local.",
        };
      }
      console.error("Error al reabrir el local:", error);
      return null;
    }
  }
}

export default LocalService;
